/**
 * List groups — the rules that judge these lists: the list verdict (what
 * today does when it judges a list a FAIL is a row of its FAIL since
 * 23/10/2026) and scaling.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import type { DropGenPlanDetail } from '../../../../drop-generator.types';
import type { ContainerEditor } from '../../state/useContainerEditor';
import { ListVerdictCard, ScalingCard, VerdictHome } from '../../verdicts/cards';
import { TAB_CHROME } from '../../tabs/tab-chrome';

interface Props {
  editor: ContainerEditor;
  plan: DropGenPlanDetail;
  containerId: string | null;
}

export const GroupVerdicts: FC<Props> = ({ editor, plan, containerId }) => (
  <VerdictHome
    title="List verdicts"
    hint="These rules judge the lists in the groups above. The same rules as on Verdicts."
    titleClass={TAB_CHROME.groups.heading}
  >
    <ListVerdictCard index={1} editor={editor} plan={plan} containerId={containerId} />
    <ScalingCard index={2} editor={editor} plan={plan} containerId={containerId} />
  </VerdictHome>
);
